var path = '/app/components/watch/watch.html';
var html = "<pre>{{$ctrl.on | json}}</pre>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;